// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1f3p-","header":"MessagesList_header__VZdHw","chat":"MessagesList_chat__2HUgT"};